import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditAttributesIcon from '@material-ui/icons/EditAttributes';
import MuiDoneIcon from '@material-ui/icons/Done';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiGetAppIcon from '@material-ui/icons/GetApp';
import MuiAccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MuiGradingIcon from '@mui/icons-material/Grading';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiErrorIcon from '@material-ui/icons/Error';
import MuiUndoIcon from '@material-ui/icons/Undo';
import MuiDeveloperBoardOffIcon from '@mui/icons-material/DeveloperBoardOff';
import MuiRefreshIcon from '@material-ui/icons/Refresh';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';

import { WithTooltip } from 'utils/wrappers';
import { API_STATUS_KEYS } from 'utils/constants';

const styles = () => ({
  buttonDone: {
    // color: theme.palette.primary.success,
  },
  buttonCancel: {
    // color: theme.palette.primary.error,
  },
  hiddenButton: {
    visibility: 'hidden',
    width: 40,
  },
});

const RowButtons = props => {
  const {
    classes,
    editing,
    onEditChange,
    onCloseClick,
    onTransferClick,
    onExportClick,
    onUnwindClick,
    onRefreshAmountClick,
    onToggleBlockBulkOperations,
    isLoadingUnwind,
    closeStatus = {},
    transferStatus = {},
    exportStatus = {},
    externalTransferMethod,
    disabled,
    hidden,
    isClosing,
    bulkOperationsBlocked,
    payment_account_id,
  } = props;

  // Listeners

  const handleEditClick = () => onEditChange(true);
  const handleCancelClick = () => onEditChange(false);
  const handleCloseClick = () => onCloseClick();
  const handleTransferClick = () => onTransferClick();
  const handleExportClick = () => onExportClick();

  // Components

  const ActionInProgress = (
    <MuiIconButton size="small" disabled={true}>
      <MuiCircularProgress size={'0.8rem'} />
    </MuiIconButton>
  );

  const ActionCloseError = (
    <WithTooltip tooltip={closeStatus[API_STATUS_KEYS.ERROR]} disabled={disabled.close}>
      <MuiIconButton size="small" onClick={handleCloseClick} disabled={disabled.close}>
        <MuiErrorIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionClose = isClosing ? (
    <MuiCircularProgress size="0.8rem" />
  ) : (
    <WithTooltip tooltip="Close (freeze royalties; generate statement)" disabled={disabled.close}>
      <MuiIconButton size="small" className={classes.buttonDone} onClick={handleCloseClick} disabled={disabled.close}>
        <MuiGradingIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionTransferError = (
    <WithTooltip tooltip={transferStatus[API_STATUS_KEYS.ERROR]} disabled={disabled.executeExternalTransfer}>
      <MuiIconButton size="small" onClick={handleTransferClick} disabled={disabled.executeExternalTransfer}>
        <MuiErrorIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionTransfer = (
    <WithTooltip tooltip={`Transfer to ${externalTransferMethod}`} disabled={disabled.executeExternalTransfer}>
      <MuiIconButton
        size="small"
        className={classes.buttonDone}
        onClick={handleTransferClick}
        disabled={disabled.executeExternalTransfer}>
        <MuiAccountBalanceIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionUnwind = (
    <WithTooltip tooltip="Unwind" disabled={disabled.unwind}>
      <MuiIconButton size="small" className={classes.buttonDone} onClick={onUnwindClick} disabled={disabled.unwind}>
        <MuiUndoIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionRefreshAmount = (
    <WithTooltip tooltip="Refresh Transfer Amount">
      <MuiIconButton size="small" onClick={onRefreshAmountClick}>
        <MuiRefreshIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionBlockBulkOperations = (
    <WithTooltip tooltip={bulkOperationsBlocked ? 'Unblock Bulk Operations' : 'Block Bulk Operations'}>
      <MuiIconButton size="small" onClick={onToggleBlockBulkOperations}>
        <MuiDeveloperBoardOffIcon fontSize="small" color={bulkOperationsBlocked ? 'error' : 'action'} />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionExport = (
    <WithTooltip tooltip="Export CSV">
      <MuiIconButton size="small" className={classes.buttonCancel} onClick={handleExportClick}>
        <MuiGetAppIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionExportError = (
    <WithTooltip tooltip={exportStatus[API_STATUS_KEYS.ERROR]}>
      <MuiIconButton size="small" onClick={handleExportClick}>
        <MuiErrorIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionCancel = (
    <WithTooltip tooltip="Cancel">
      <MuiIconButton size="small" className={classes.buttonCancel} onClick={handleCancelClick}>
        <MuiBlockIcon fontSize="small" />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionSuccess = (
    <MuiIconButton size="small" className={classes.buttonDone} disabled={true}>
      <MuiDoneIcon fontSize="small" />
    </MuiIconButton>
  );

  const ActionViewReleases = (
    <WithTooltip tooltip="View Payee Releases">
      <MuiIconButton size="small">
        <a href={`/manage-releases/payment-account/${payment_account_id}`}>
          <LibraryMusicIcon fontSize="small" />
        </a>
      </MuiIconButton>
    </WithTooltip>
  );

  const ExportButton = () => {
    if (hidden.export) return null;
    if (exportStatus[API_STATUS_KEYS.IN_PROGRESS]) return ActionInProgress;
    if (exportStatus[API_STATUS_KEYS.ERROR]) return ActionExportError;
    return ActionExport;
  };

  return (
    <>
      {!editing && !hidden.cancel ? (
        <>
          <WithTooltip tooltip="Reveal Row Actions" key="edit">
            <MuiIconButton size="small" onClick={handleEditClick}>
              <MuiEditAttributesIcon fontSize="small" />
            </MuiIconButton>
          </WithTooltip>
        </>
      ) : (
        <>
          {!hidden.close &&
            (closeStatus[API_STATUS_KEYS.IN_PROGRESS] || isLoadingUnwind ? (
              ActionInProgress
            ) : closeStatus[API_STATUS_KEYS.ERROR] ? (
              ActionCloseError
            ) : closeStatus[API_STATUS_KEYS.COMPLETE] ? (
              ActionSuccess
            ) : (
              <>
                {ActionClose}
                {ActionUnwind}
              </>
            ))}
          {!hidden.executeExternalTransfer &&
            (transferStatus[API_STATUS_KEYS.IN_PROGRESS] ? (
              ActionInProgress
            ) : transferStatus[API_STATUS_KEYS.ERROR] ? (
              ActionTransferError
            ) : transferStatus[API_STATUS_KEYS.COMPLETE] ? (
              ActionSuccess
            ) : (
              <>{ActionTransfer}</>
            ))}
          {ExportButton()}
          {ActionViewReleases}
          {ActionBlockBulkOperations}
          {ActionRefreshAmount}
          {!hidden.cancel && ActionCancel}
        </>
      )}
    </>
  );
};

RowButtons.defaultProps = {
  disabled: {},
  hidden: {},
  onEditChange: () => {},
  onCloseClick: () => {},
  onTransferClick: () => {},
  onExportClick: () => {},
  onViewReleasesClick: () => {},
  onRefreshAmount: () => {},
  closeStatus: {},
  transferStatus: {},
  exportStatus: {},
};

export default withStyles(styles)(RowButtons);
